// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fetchWrapper } from 'helpers/api'

// TODO - should this end point support filtering by domainId?
export const fetchFrequencyPlans = q => fetchWrapper(`/frequency-plans${q}`)

export const fetchFrequencyPlanById = id => fetchWrapper(`/frequency-plans/${id}`)

export const fetchFrequencyPolarizations = () => fetchWrapper(`/polarizations`)
